declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

//import { DBOperation } from '../../../../../enums/enum';
import { ActorEmploymentPreferencesRequest } from '../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../services/hcp.service';


import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest, SaveProviderServiceChargeRequest, SaveSingleEmbryoGradeInfoRequest, ActorImageController } from '../../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../../models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../../models/master/mastermodel';
import { FDService } from '../../../../services/fd.service';
import { ConsultantMapPipe } from '../../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';
import { NgbActorDocsModal } from '../../profile/modals/actordocs/actordocs.modal';

@Component({
  selector: 'ngbeditgrading',
  templateUrl: './editgrading.modal.html',
  styleUrls: ['./editgrading.modal.scss']
})

export class NgbEditGradingModal implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;

    @Input() IsShowDetail: boolean = false;
    @Input() EmbryoGradeCode: number;
    @Input() DocumentUrl: string;
    @Input() CurrentSaveSingleEmbryoGradeInfoRequest: SaveSingleEmbryoGradeInfoRequest;
    @Input() ServiceCode: number;
    @Input() Wellno: number;
    @Input() ImageCodenew: number;
    @Input() Technique: string;
    @Input() oqa: string;
    @Input() Day: number;
    @Input() PatientName: string;
    @Input() Cyclenumber: number;
    @Input() ActorCode: number;
  searchTitle: string;
  public ApiResData: ApiResponseModel;
    ValueChangeActorImageController: ActorImageController;
  public isRequesting: boolean = false;
  public ShowService: boolean = true;
  public discard: boolean = true;
  public freeze: boolean = false;
  public Transfer: boolean = false;
  //public IsSelected: boolean;
  CurrentSaveProviderServiceChargeRequest: SaveProviderServiceChargeRequest;
  CurrentDeleteProviderServiceChargeRequest: SaveProviderServiceChargeRequest;
  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
    private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe,
    private router: Router, private route: ActivatedRoute, private hcpservice: HCPService,
      private tosterservice: NGXToastrService, private modalService: NgbModal) { }
  ngOnInit() {
    this.CurrentSaveProviderServiceChargeRequest = new SaveProviderServiceChargeRequest();
    //this.CurrentSaveProviderServiceChargeRequest.ConditionalOperator = 20;
    this.CurrentSaveProviderServiceChargeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentDeleteProviderServiceChargeRequest = new SaveProviderServiceChargeRequest();
    this.CurrentDeleteProviderServiceChargeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.ShowService = false;
      this.ValueChangeActorImageController = new ActorImageController();

    //this.LoadRegistries();
    

  }

  
  
  //GetBranchMap() {
  //  this.StartRefreshing();
  //  this.BranchMapRequest.ServiceCode = this.ServiceCode;

  //  this.actorservice.GetServiceBranchMapByServiceCodeController(this.BranchMapRequest)
  //    .subscribe((result) => {
  //      this.ApiResData = result;
  //      if (!this.ApiResData.hasError) {

  //        this.BranchMapData = this.ApiResData.Result;
  //        //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
  //        //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
  //        //this.CurrentServiceDetailsByCodeRequest.ServiceCode = this.ServiceCode;
  //        this.stopRefreshing();

  //      }
  //      else {
  //        this.stopRefreshing();
  //        if (this.ApiResData.ErrorData != "") {

  //          alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
  //        }
  //        else {
  //          alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
  //        }
  //      }

  //    },


  //      (error) => {

  //        if (error == "401 - Unauthorized") {
  //          alertFunctions.AlertParamEr(error);
  //          this.stopRefreshing();



  //        }
  //        else {
  //          alertFunctions.AlertParamEr(error);
  //          this.stopRefreshing();
  //        }
  //      }


  //    );


  //}
    
    openDocContent() {
       
            let options: NgbModalOptions = {
                size: 'lg'
            };
            const modalRef = this.modalService.open(NgbActorDocsModal, options)//.result(result => { this.GetActorProfileController();});
        modalRef.componentInstance.ActorDocCode = this.ImageCodenew;
        //alert(this.ImageCodenew);
        modalRef.componentInstance.ActorCode = this.ActorCode;
        modalRef.componentInstance.DocType= "Embryo Grading";
        modalRef.componentInstance.DocTitle= "Embryo Grading";
            //modalRef.componentInstance.CanEdit = 1;
            //modalRef.componentInstance.CanShow = 1;
        modalRef.result.then(x => {
          //  alert('Received: ' + x);
            var data: ApiResponseModel = x;
            this.ImageCodenew = data.Result;
        //    this.GetActorIdentitiesController()
        })
       
       
    }
    onSubmit() {

        this.StartRefreshing();
        //alert(this.CurrentActorEmploymentPreferencesRequest.ReasonForAccommodation);
        this.CurrentSaveSingleEmbryoGradeInfoRequest.ConditionalOperator = 10;
        this.CurrentSaveSingleEmbryoGradeInfoRequest.Imagecode = this.ImageCodenew;// this.ValueChangeActorImageController.ActorImageCode;
        this.CurrentSaveSingleEmbryoGradeInfoRequest.EmbryoGradeCode = this.EmbryoGradeCode;
        this.actorservice.SaveSingleEmbryoGradeInfo(this.CurrentSaveSingleEmbryoGradeInfoRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        this.ShowService = false;
                        //alertFunctions.AlertParam('Saved Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

                        this.activeModal.close();

                        this.stopRefreshing();
                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");
                        this.activeModal.close();

                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                        this.activeModal.close();


                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                        this.activeModal.close();
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.activeModal.close();
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.activeModal.close();
                        this.stopRefreshing();
                    }
                }
            );

    }


  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
    
 
  discarddata() {
    this.freeze = false;
    this.Transfer = false;
    this.discard = true;
  }
  Freezedata() {
    this.discard = false;
    this.Transfer = false;
    this.freeze = true;
  }
  Transferdata() {
    this.freeze = false;
    this.discard = false;
    this.Transfer = true;
  }



}
